module.exports = __webpack_public_path__ + "static/media/virusmessage.d4baa707.jpg";